'use client';

import styled, { css } from 'styled-components';

import { breakpoints, colors } from '@/styles/theme';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  gap: 8px;
  padding: 1rem;
  min-width: ${({ $rating }) => ($rating ? '172px' : '130px')};

  color: ${colors.silver};
  border-radius: 12px;

  border: 1px solid ${colors.gray5};
  background: ${colors.dark};
  opacity: 0.9;

  @media (max-width: ${breakpoints.tablet}) {
    flex: 1;
    gap: 4px;
    min-width: 124px;
  }

  @media (max-width: ${breakpoints.mobile}) {
    padding: 8px;
  }
`;

export const Number = styled.div`
  display: flex;
  align-items: center;

  gap: 8px;

  text-align: start;
  font-size: 2rem;
  line-height: 2.17rem;
  font-weight: 600;
  color: ${colors.light};

  @media (max-width: ${breakpoints.tablet}) {
    font-size: 2rem;
  }

  @media (max-width: ${breakpoints.mobile}) {
    font-size: 1.5rem;

    .mantine-Rating-symbolBody {
      > svg {
        height: 22px;
        width: 22px;
      }
    }
  }

  @keyframes showStars {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }

  & > div {
    display: none;
  }

  ${({ $showStars }) =>
    $showStars &&
    css`
      & > div {
        display: flex;
        animation-name: showStars;
        animation-duration: 4s;
        animation-fill-mode: forwards;
      }

      & > span {
        display: none;
      }
    `}
`;

export const Title = styled.div`
  font-size: 1rem;

  text-align: start;
  color: ${colors.brown};
  white-space: nowrap;
  font-weight: 300;

  @media (max-width: ${breakpoints.tablet}) {
    font-size: 1rem;
  }

  @media (max-width: ${breakpoints.mobile}) {
    font-size: 0.8rem;
  }
`;
